import moment from 'moment';

/**
 * This retrieves the current local time with any timezone
 * offset removed/set to UTC.
 *
 * If the local time is 6:00am PDT, this returns a moment
 * representing 6:00am UTC
 */
export const getCurrentMomentWithoutOffsetInLocalTime = () => moment().utcOffset(0, true);

const createFormatter = (language?: string) =>
    new Intl.DateTimeFormat(language ? language : [], {
        month: 'long',
        day: 'numeric',
        weekday: 'short',
    });

export const formatDailyPauseMoment = (currentMoment: moment.Moment, language?: string) => {
    const formatter = createFormatter(language);
    return formatter.format(currentMoment.toDate());
};
